import { ReactElement } from 'react'
import { VscHome, VscFolder, VscAccount, VscMegaphone } from 'react-icons/vsc'
// import { TbWallpaper } from 'react-icons/tb'

export type AppConfig = Array<{ icon: ReactElement, path: string, title: string }>

export const appConfig: AppConfig = [
  { icon: <VscHome />, path: '/', title: 'home' },
  // { icon: <TbWallpaper />, path: '/news', title: 'news' },
  { icon: <VscFolder />, path: '/projects', title: 'projects' },
  { icon: <VscAccount />, path: '/aboutme', title: 'aboutme' },
  { icon: <VscMegaphone />, path: '/contact', title: 'contact' }
]